// @flow
import * as React from 'react';

type FormStyles = Object

const FormStylesContext: React.Context<FormStyles> = React.createContext({});

export default FormStylesContext;
